import { useEffect, useState } from "react";
import { addLogs, formatizeJson, removeUndefinedProperties, validateData } from "../actions/VimActions";
import IconsAndTextComp from "./NoteDetails/IconsAndText";
import copytoemr from "../images/Copy to EMR.svg";
import copiedEmr from "../images/arrow-ehr.svg";
import { ShowAlert } from "../../newCreateContent/CreateContentAlert";
import { useUpdateEncounter } from "./EncounterContext";

const NotesListPushToEhr = ({ isCopiedToEhr, buttonClicked = () => { }, isNotLoadedOnVim }) => {
   const [isCopied, setIsCopied] = useState(isCopiedToEhr);
   const [error, showError] = useState(false);
   useEffect(() => {
      if (isCopiedToEhr) {
         setIsCopied(true);
      }
   }, [isCopiedToEhr]);
   return (
      <>
         <div
            onClick={(e) => {
               e.stopPropagation();
               if (isCopied) return;
               buttonClicked((isError) => {
                  if (isError) {
                     showError(true);
                  } else {
                     setIsCopied(true);
                  }
               });
            }}
            className={error ? "error-copy-emr" : isCopied ? "copied-emr-vim" : "not-in-emr-chip"}
         >
            {error ? (
               <div className="d-flex align-items-center">Copy Error</div>
            ) : isCopied ? (
               <div className="d-flex align-items-center">
                  Copied
                  <img width={24} height={24} src={copiedEmr} alt="copied-emr" />
               </div>
            ) : (
               "Copy to EHR"
            )}
         </div>
      </>
   );
};

export const WriteNoteToEhr = ({
   noteObject,
   noteId,
   forNotesList = false,
   isCopiedToEhr,
   getNotes,
   encounter,
   isNotLoadedOnVim,
}) => {
   const { canUpdate, updateEncounter } = useUpdateEncounter();
   const buttonClicked = (callback = () => { }) => {
      let obj = removeUndefinedProperties(formatizeJson([noteObject]));
      const canUpdateResult = canUpdate(obj);
      const sanitizedObj = validateData(canUpdateResult, obj);
      console.log(canUpdateResult, "canUpdateResult")
      if (canUpdateResult?.details && Object.keys(canUpdateResult.details).length === 0) {
         ShowAlert("Your Note could not be copied. Please try again.", "error");
         callback(true);
         return;
      }
      console.log("sanitizedObj", sanitizedObj);
      console.log("sanitizedObj", window.vimOS);
      if (encounter) {
         updateEncounter(sanitizedObj)
            .then((res) => {
               callback(false);
               addLogs(noteId);
               getNotes();
            })
            .catch((error) => {
               console.log("error-->", error)
               ShowAlert("Your Note could not be copied. Please try again.", "error");
               callback(true);
            });
      } else {
         ShowAlert("Error! Go to the Note Entry Screen in your EMR and try again.", "error");
      }
   };

   useEffect(() => {
      const cb = () => { };
      window?.vimOS?.ehr?.resourceUpdater?.subscribe("encounter", cb);
      return () => {
         window?.vimOS?.ehr?.resourceUpdater?.unsubscribe("encounter", cb);
      };
   }, []);

   return forNotesList ? (
      <NotesListPushToEhr
         isNotLoadedOnVim={isNotLoadedOnVim}
         isCopiedToEhr={isCopiedToEhr}
         noteId={noteId}
         noteObject={noteObject}
         buttonClicked={buttonClicked}
      />
   ) : (
      <>
         {!isNotLoadedOnVim && (
            <IconsAndTextComp
               isNotLoadedOnVim={isNotLoadedOnVim}
               title="Copy to EHR"
               src={copytoemr}
               onClick={() => {
                  buttonClicked();
               }}
            />
         )}
      </>
   );
};
